// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b5f3aa29","396":"ee369c5e","455":"f68d8505","977":"f3b9ab83"}[chunkId] + ".chunk.js";
};